import React from 'react';
import { Routes, Route, Outlet, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Devis from './pages/Devis';
import Realisations from './pages/Realisations';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import APropos from './pages/APropos';
import Contact from './pages/Contact';
import Assistant from './pages/Assistant';
import NotFound from './pages/NotFound';
import LogoPreview from './pages/LogoPreview';
import MentionsLegales from './pages/MentionsLegales';
import Confidentialite from './pages/Confidentialite';
import CGV from './pages/CGV';

// Pro (iPad)
import ProLayout from './components/pro/ProLayout';
import ProActivation from './pages/pro/ProActivation';
import BriefEquipe from './pages/BriefEquipe';
import ProLogin from './pages/pro/ProLogin';
import EspaceClient from './pages/EspaceClient';
import GrillePrix from './pages/GrillePrix';
import ProDashboard from './pages/pro/ProDashboard';
import ProDevis from './pages/pro/ProDevis';
import ProDossier from './pages/pro/ProDossier';
import ProReferentiel from './pages/pro/ProReferentiel';
import ProChantiers from './pages/pro/ProChantiers';
import ProDeviseur from './pages/pro/ProDeviseur';
import ProComptes from './pages/pro/ProComptes';
import ProEquipe from './pages/pro/ProEquipe';

function PublicLayout() {
  return <Layout><Outlet /></Layout>;
}

function App() {
  return (
    <Routes>
      {/* ── Pro routes (own layout, no Header/Footer) ── */}
      {/* Espace client : hors Layout (pas de menu ni de CTA devis — le client est déjà client) */}
      <Route path="/espace/:token" element={<EspaceClient />} />
      <Route path="/brief/:token" element={<BriefEquipe />} />
      <Route path="/grille/:id" element={<GrillePrix />} />
      <Route path="/pro/login" element={<ProLogin />} />
      <Route path="/pro/activation/:token" element={<ProActivation />} />
      <Route path="/pro/dossier" element={<ProDossier />} />
      <Route path="/pro" element={<ProLayout />}>
        <Route index element={<ProDashboard />} />
        {/* Un devis naît d'un relevé analysé : l'ancien wizard vide renvoie à « Nouveau devis ». */}
        <Route path="devis/new" element={<Navigate to="/pro/deviseur" replace />} />
        <Route path="devis/:ref" element={<ProDevis />} />
        <Route path="deviseur" element={<ProDeviseur />} />
        <Route path="comptes" element={<ProComptes />} />
        <Route path="chantiers" element={<ProChantiers />} />
        <Route path="referentiel" element={<ProReferentiel />} />
        <Route path="equipe" element={<ProEquipe />} />
      </Route>

      {/* ── Public site (Header + Footer) ── */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/devis" element={<Devis />} />
        <Route path="/realisations" element={<Realisations />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/a-propos" element={<APropos />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/assistant" element={<Assistant />} />
        <Route path="/logo-preview" element={<LogoPreview />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/confidentialite" element={<Confidentialite />} />
        <Route path="/cgv" element={<CGV />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default App;
